module.exports = __webpack_public_path__ + "img/icon_manejo_de_referidos_seguimiento.e456c2a3.svg";